module.exports = ol.style.Fill;